import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Grid,
  IconButton,
  Button,
  InputAdornment,
  Box,
  Typography,
} from "@mui/material";
import { Delete, Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ClientAutocomplete from "../../components/clientAutocomplete";
import { asnService } from "../../utils/services/asnService";
import dayjs from "dayjs";
import CalendarIcon from "@mui/icons-material/CalendarMonthOutlined";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { toast } from "react-toastify";
import { isMobile } from "../../globalStyles/mobile";
import AutocompleteWithPagination from "../../components/autocomplete-with-pagination";
import { purchaseOrderService } from "../../utils/services/purchaseOrderService";
import { supplierService } from "../../utils/services/supplierService";
import { productService } from "../../utils/services/productService";
import { clientConfigService } from "../../utils/services/clientConfigService";
import { padNumberWithZeros } from "../../utils/utility";
import { wmsService } from "../../utils/services/wmsProvider";
import MultiKeyAutocompleteWithPagination from "../../components/multi-key-autocomplete-with-pagination";

let init_data = {
  asn_no: "",
  supplier: null,
  sku_list: [
    {
      id: 1,
      sku: null,
      quantity_requested: "",
      product: null,
      variant_id: null,
      label: "",
      name: "",
      inventoryConfig: null,
      warehouse: null,
    },
  ],
  client: null,
  status: "Created",
  expected_dispatch_date: null,
  purchase_order: null,
};
const CreatePurchaseOrder = () => {
  const [formData, setFormData] = useState(init_data);
  const [selectedClient, setSelectedClient] = useState(null);
  const navigate = useNavigate();
  let client_id = localStorage.getItem("client_id");
  const [showCalendar, setShowCalendar] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const calendarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        event.target.getAttribute("name") !== "date-field"
      ) {
        setShowCalendar(null);
      }
    }

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showCalendar]);

  const validateForm = () => {
    let errors = {};
    if (!formData.asn_no) errors.asn_no = "P.O. Number is required";
    if (!formData.supplier) errors.supplier = "Select a Supplier";
    if (!formData.expected_dispatch_date)
      errors.expected_dispatch_date = "Expected Arrival Date is required";
    if (!client_id && !formData.client) errors.client = "Client is required";

    formData.sku_list.forEach((sku, index) => {
      if (!sku.sku) errors[`sku_${index}`] = "SKU is required";
      if (!sku.warehouse)
        errors[`warehouse_${index}`] = "Warehouse is required";
      if (
        sku.inventoryConfig &&
        (!sku.quantity_requested ||
          sku.quantity_requested < sku.inventoryConfig.min_order_quantity)
      )
        errors[`quantity_requested_${index}`] =
          `Quantity must be greater than or equal to ${sku.inventoryConfig.min_order_quantity}`;
      else if (!sku.quantity_requested || sku.quantity_requested < 1)
        errors[`quantity_requested_${index}`] =
          "Quantity must be greater than 0";
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  // Add SKU Row
  const addSkuRow = () => {
    setFormData((prev) => ({
      ...prev,
      sku_list: [
        ...prev.sku_list,
        {
          id: prev.sku_list.length + 1,
          sku: null,
          quantity_requested: "",
          product: null,
          variant_id: null,
          label: "",
        },
      ],
    }));
  };

  console.log(formData);

  // Remove SKU Row
  const removeSkuRow = (id) => {
    setFormData((prev) => ({
      ...prev,
      sku_list: prev.sku_list.filter((row) => row.id !== id),
    }));
    setFormErrors((prev) => {
      let updatedErrors = { ...prev };
      delete updatedErrors[`sku_${id - 1}`];
      delete updatedErrors[`quantity_${id - 1}`];
      return updatedErrors;
    });
  };

  // Handle changes to ASN or SKU data
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => {
      let updatedErrors = { ...prev };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  const handleSkuChange = (id, field, value) => {
    setFormData((prev) => ({
      ...prev,
      sku_list: prev.sku_list.map((sku) =>
        sku.id === id ? { ...sku, [field]: value } : sku,
      ),
    }));
    setFormErrors((prev) => {
      let updatedErrors = { ...prev };
      delete updatedErrors[`${field}_${id - 1}`];
      return updatedErrors;
    });
  };

  const handleSkuSelect = (id, sku) => {
    setFormData((prev) => {
      let obj = {
        ...prev,
        sku_list: prev.sku_list.map((skuRow) =>
          skuRow.id === id
            ? {
                id: id,
                label: sku?.label,
                sku: sku?.variants?.sku,
                product: sku?._id,
                variant_id: sku?.variants?._id,
                name: sku.name,
                inventoryConfig: sku.inventoryConfig,
                quantity_requested: skuRow.quantity_requested,
                warehouse: skuRow.warehouse,
                variant: sku.variant,
              }
            : skuRow,
        ),
      };
      if (sku.supplier && !obj.supplier) {
        obj.supplier = sku.supplier;
      }
      setFormErrors((prev) => {
        let updatedErrors = { ...prev };
        delete updatedErrors[`sku_${id - 1}`];
        delete updatedErrors[`supplier`];
        return updatedErrors;
      });
      return obj;
    });
  };

  const handleWarehouseSelect = (id, warehouse) => {
    setFormData((prev) => {
      let obj = {
        ...prev,
        sku_list: prev.sku_list.map((skuRow) =>
          skuRow.id === id
            ? {
                ...skuRow,
                warehouse: warehouse,
              }
            : skuRow,
        ),
      };
      return obj;
    });
    setFormErrors((prev) => {
      let updatedErrors = { ...prev };
      delete updatedErrors[`warehouse_${id - 1}`];
      return updatedErrors;
    });
  };

  const handleSubmit = async () => {
    try {
      if (!validateForm()) return;
      let obj = {
        ...formData,
        client: client_id ?? formData.client._id,
        supplier: formData.supplier?._id,
        purchase_order: formData.purchase_order?._id,
        expected_dispatch_date: formData.expected_dispatch_date,
        sku_list: formData.sku_list.map((row) => ({
          sku: row.sku,
          product: row.product,
          variant_id: row.variant_id,
          quantity_requested: row.quantity_requested,
          inventory_config: row.inventoryConfig
            ? row.inventoryConfig._id
            : null,
          warehouse: row.warehouse ? row.warehouse._id : null,
        })),
      };

      console.log(obj);

      let response = await asnService.create(obj);
      if (response) {
        navigate("/purchase-order?child=true");
        setFormData(init_data);
        setSelectedClient(null);
        setFormErrors({});
        setShowCalendar(false);
        toast.success("P.O. created successfully", { autoClose: 2000 });
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (client_id || selectedClient?._id) {
      fetchOrderPrefix();
    }
  }, [client_id, selectedClient]);

  let orderPrefix = "";

  const fetchOrderPrefix = async () => {
    try {
      const response = await clientConfigService.fetch(
        client_id || selectedClient?._id,
        1,
        0,
        "purchase_order_prefix",
      );
      fetchPurchaseOrderCount();

      if (response && response.total > 0) {
        orderPrefix = response.data[0].value || "";
      }
    } catch (error) {
      console.error("Error fetching order prefix:", error);
    }
  };

  const fetchPurchaseOrderCount = async () => {
    try {
      const response = await asnService.fetch(
        "$limit=0",
        client_id || selectedClient?._id,
      );
      setFormData((prevOrder) => ({
        ...prevOrder,
        asn_no: `${orderPrefix}${padNumberWithZeros(response.total + 1)}`,
      }));
    } catch (error) {
      console.error("Error fetching order count:", error);
    }
  };

  return (
    <>
      <Box
        sx={{
          padding: "20px",
          maxHeight: isMobile ? "calc(100vh - 200px)" : "calc(100vh - 150px)",
          overflowY: "auto",
        }}
      >
        {/* ASN Number and Supplier Selection */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            mb: 2,
          }}
        >
          <Typography
            fontFamily={"poppins"}
            fontSize={"14px"}
            fontWeight={500}
          >
            Basic Information
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              onClick={() => {
                navigate("/purchase-order?child=true");
                setFormData(init_data);
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              Create
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            border: "1px solid var(--border-color)",
            padding: "20px",
            margin: "20px 0",
            borderRadius: "4px",
          }}
        >
          <Grid container spacing={2} alignItems="center" mb={2}>
            {!client_id && (
              <Grid item xs={12}>
                <ClientAutocomplete
                  backgroundColor="var(--bg-paper)"
                  label="Choose Client"
                  selectedClient={selectedClient}
                  onClientChange={(client) => {
                    if (client) {
                      setSelectedClient({
                        _id: client._id,
                        name: client.name,
                        business_name: client.business_name,
                      });
                      setFormData((prev) => ({ ...prev, client: client }));
                      setFormErrors((prev) => {
                        let updatedErrors = { ...prev };
                        delete updatedErrors["client"];
                        delete updatedErrors["asn_no"];
                        return updatedErrors;
                      });
                    }
                  }}
                  errorMessage={formErrors.client}
                  width={"100%"}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <TextField
                sx={{ backgroundColor: "var(--bg-paper)" }}
                size="small"
                name="asn_no"
                label="P.O. Number"
                value={formData.asn_no}
                onChange={(e) => handleInputChange("asn_no", e.target.value)}
                fullWidth
                margin="dense"
                error={!!formErrors.asn_no}
                helperText={formErrors.asn_no}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <AutocompleteWithPagination
                key={formData.purchase_order ? "selected" : "none"}
                selectedClient={selectedClient}
                backgroundColor={"var(--bg-paper)"}
                customLabel={"Master P.O."}
                disabled={!(client_id || selectedClient?._id)}
                selectedItem={formData.purchase_order}
                onDataChange={(e) => {
                  if (e) {
                    setFormData({
                      ...formData,
                      purchase_order: e,
                      supplier: e.supplier,
                    });
                  } else {
                    setFormData({
                      ...formData,
                      purchase_order: null,
                      supplier: null,
                    });
                  }
                }}
                width={"100%"}
                optionKey={"no"}
                apiEndPoint={(limit, skip, search, client) =>
                  purchaseOrderService.fetch(
                    `$limit=${limit}&$skip=${skip}&$populate=supplier&expiration_date[$gte]=${new Date().toISOString()}&date[$lte]=${new Date().toISOString()}`,
                    client,
                    search,
                  )
                }
              ></AutocompleteWithPagination>
            </Grid>

            <Grid item xs={12} sm={6}>
              <AutocompleteWithPagination
                disabled={
                  !(client_id || selectedClient?._id) ||
                  (formData.purchase_order && formData.supplier)
                }
                selectedClient={selectedClient}
                backgroundColor={"var(--bg-paper)"}
                customLabel={"Supplier"}
                selectedItem={formData.supplier}
                onDataChange={(e) => {
                  if (e) {
                    setFormErrors((prev) => {
                      let updatedErrors = { ...prev };
                      delete updatedErrors["supplier"];
                      return updatedErrors;
                    });
                    setFormData((prev) => ({
                      ...prev,
                      supplier: e,
                      sku_list: init_data.sku_list,
                      purchase_order: null,
                    }));
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      supplier: null,
                      sku_list: init_data.sku_list,
                      purchase_order: null,
                    }));
                  }
                }}
                width={"100%"}
                optionKey={"name"}
                apiEndPoint={(limit, skip, search, client) =>
                  supplierService.fetch(
                    search,
                    client,
                    `$limit=${limit}&$skip=${skip}`,
                  )
                }
                errorMessage={formErrors["supplier"]}
              ></AutocompleteWithPagination>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="date-field"
                margin="dense"
                label="Expected Dispatch Date"
                size="small"
                value={
                  formData.expected_dispatch_date
                    ? dayjs(formData.expected_dispatch_date).format(
                        "YYYY-MM-DD",
                      )
                    : ""
                }
                onFocus={() => setShowCalendar(!showCalendar)}
                inputProps={{ readOnly: true }}
                fullWidth
                variant="outlined"
                InputProps={
                  formData.expected_dispatch_date
                    ? {
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              onClick={() => setShowCalendar(!showCalendar)}
                            >
                              <CalendarIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }
                    : null
                }
                error={!!formErrors.expected_dispatch_date}
                helperText={formErrors.expected_dispatch_date}
                sx={{ backgroundColor: "var(--bg-paper)" }}
              />
            </Grid>
          </Grid>
        </Box>

        <Box>
          <Typography
            fontFamily={"poppins"}
            fontSize={"14px"}
            fontWeight={500}
            sx={{ mb: 2, display: "flex" }}
          >
            P.O. Information
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: 1,
              width: "100%",
              border: "1px solid var(--border-color)",
              padding: "20px",
              maxHeight: isMobile() ? "calc(100vh - 580px)" : 350,
              overflowY: "auto",
              borderRadius: "4px",
            }}
          >
            {formData.sku_list.map((row, index) => (
              <Grid
                container
                spacing={2}
                alignItems="center"
                key={row._id}
                mt={1}
              >
                <Grid item xs={12} sm={5}>
                  <MultiKeyAutocompleteWithPagination
                    disabled={!(client_id || selectedClient?._id)}
                    supplier={formData.supplier?._id}
                    selectedClient={selectedClient}
                    backgroundColor={"var(--bg-paper)"}
                    customLabel={"SKU"}
                    selectedItem={row || null}
                    onDataChange={(sku) => {
                      if (sku) {
                        handleSkuSelect(row.id, sku);
                      } else {
                        handleSkuSelect(row.id, "");
                      }
                    }}
                    width={"100%"}
                    primaryKey={"variant.sku"}
                    parenthesisKey={"variant.title"}
                    secondLineKey={"name"}
                    apiEndPoint={(limit, skip, search, client, supplier) =>
                      productService.fetchSKU(
                        client,
                        search,
                        limit,
                        skip,
                        formData.sku_list
                          .map((x) => x.variant_id)
                          .filter((x) => x),
                        supplier,
                      )
                    }
                    errorMessage={formErrors[`sku_${index}`]}
                  ></MultiKeyAutocompleteWithPagination>
                </Grid>
                <Grid item xs={12} sm={3.5}>
                  <AutocompleteWithPagination
                    disabled={!(client_id || selectedClient?._id)}
                    selectedClient={selectedClient}
                    backgroundColor={"var(--bg-paper)"}
                    customLabel={"Warehouse"}
                    selectedItem={row.warehouse || null}
                    onDataChange={(wh) => {
                      if (wh) {
                        handleWarehouseSelect(row.id, wh);
                      } else {
                        handleWarehouseSelect(row.id, "");
                      }
                    }}
                    width={"100%"}
                    optionKey={(item) =>
                      `${item.name} (${item.warehouse_code})`
                    }
                    apiEndPoint={(limit, skip, search, client) =>
                      wmsService.fetch(client, limit, skip, null)
                    }
                    errorMessage={formErrors[`warehouse_${index}`]}
                  ></AutocompleteWithPagination>
                </Grid>
                <Grid item xs={10} sm={2.25}>
                  <TextField
                    disabled={!(client_id || selectedClient?._id)}
                    sx={{ backgroundColor: "var(--bg-paper)", mt: 0.5 }}
                    label="Quantity"
                    fullWidth
                    type="number"
                    size="small"
                    value={row.quantity_requested}
                    onChange={(e) =>
                      handleSkuChange(
                        row.id,
                        "quantity_requested",
                        e.target.value,
                      )
                    }
                    inputProps={{
                      min: row?.inventoryConfig?.min_order_quantity || 1,
                    }}
                    error={!!formErrors[`quantity_requested_${index}`]}
                    helperText={formErrors[`quantity_requested_${index}`]}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sx={{ display: "flex", alignItems: "center" }}
                  sm={1}
                >
                  {formData.sku_list.length > 1 && (
                    <IconButton
                      disabled={!(client_id || selectedClient?._id)}
                      onClick={() => removeSkuRow(row.id)}
                    >
                      <Delete color="error" />
                    </IconButton>
                  )}
                  {index === formData.sku_list.length - 1 && (
                    <IconButton
                      disabled={!(client_id || selectedClient?._id)}
                      onClick={addSkuRow}
                    >
                      <Add color="primary" />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>

        {showCalendar && (
          <Box
            ref={calendarRef}
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 3000,
              bgcolor: "var(--bg-paper)",
              boxShadow: 3,
              borderRadius: 1,
              p: 0.5,
              width: 300,
            }}
          >
            <Calendar
              value={new Date(formData.expected_dispatch_date)}
              onChange={(e) => {
                setFormData({ ...formData, expected_dispatch_date: e });
                setShowCalendar(false);
                setFormErrors((prev) => {
                  let updatedErrors = { ...prev };
                  delete updatedErrors["expected_dispatch_date"];
                  return updatedErrors;
                });
              }}
              minDate={new Date()}
              maxDate={
                formData.purchase_order?.expiration_date
                  ? new Date(formData.purchase_order.expiration_date)
                  : null
              }
              className="custom-calendar"
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default CreatePurchaseOrder;
